var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"map-title"},[_vm._v("Distribución geografica")]),_c('div',{staticClass:"map-subtitle"},[_vm._v("de la variable seleccionada")]),_c('v-chart',{attrs:{"id":"map-chart","options":_vm.graph}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }